module.exports = __webpack_public_path__ + "static/media/explode.f0462ce4.wav";


//////////////////
// WEBPACK FOOTER
// ./src/game/assets/sounds/explode.wav
// module id = 61
// module chunks = 0